"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegalDetailsForm = void 0;
var _zod = require("@hookform/resolvers/zod");
var _mui = require("@ori-ui/mui");
var _commonFormFields = require("@ori/common-form-fields");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../../contexts");
var _models = require("../../../models");
var _api = require("../../../models/api");
var _utils = require("../../../utils");
var _FormValidationSummary = require("../../FormValidationSummary");
var _PersonalConsent = require("../../PersonalConsent");
var _TermsConditionsCheckbox = require("../../TermsConditionsCheckbox");
var _LegalDetailApprovals = require("./LegalDetailApprovals");
var _LegalDocuments = require("./LegalDocuments");
var _StyledComponentsLegalForm = require("./StyledComponentsLegalForm");
var _validationSchema = require("./validationSchema");
var _jsxRuntime = require("react/jsx-runtime");
const LegalDetailsForm = props => {
  const {
    initialData,
    config,
    isSuccessSubmit,
    isRedirectToBasketEnabled,
    onSubmitForm,
    isParentalConsent
  } = props;
  const {
    stepperData
  } = (0, _contexts.useStepperData)();
  const {
    activeStep,
    setActiveStep,
    stepsOrder
  } = stepperData;
  const {
    data: personalData
  } = (0, _api.usePersonalData)();
  const {
    data: registrationData
  } = (0, _api.useRegistrationData)();
  const [isParentalRequired, setIsParentalRequired] = (0, _react.useState)(false);
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    customerServiceUrl
  } = (0, _contexts.useConfiguration)();
  const isUnderParentalConsentAge = (0, _utils.getIsUnderParentalConsentAge)(config?.parentalConsent, personalData?.birthDate);
  const contactEmail = personalData?.contactEmail?.toLowerCase() ?? registrationData?.contactEmail?.toLowerCase();
  const contactPhone = personalData?.contactTelephone ?? registrationData?.contactTelephone;
  const validationSchema = (0, _validationSchema.useGetSchema)(isParentalRequired, config, contactPhone, contactEmail);
  const methods = (0, _reactHookForm.useForm)({
    defaultValues: initialData,
    reValidateMode: 'onChange',
    shouldFocusError: true,
    mode: 'all',
    resolver: (0, _zod.zodResolver)(validationSchema)
  });
  const {
    watch,
    formState,
    trigger
  } = methods;
  const {
    isValid,
    isSubmitting
  } = formState;
  const values = watch();
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    customErrors
  } = errorData;
  const identityErr = Object.keys(values.identityCard ?? {}).map(value => `identityCard.${value}`);
  const prevValues = Object.keys(values);
  const identityValues = identityErr;
  const newValues = [...prevValues, ...identityValues];
  const invalidCodeErrors = customErrors?.filter(er => !newValues.map(val => val.toLowerCase()).includes(er.fieldName?.toLowerCase() ?? ''));
  const availableApprovals = config?.approvals && Object.values(config.approvals).filter(approval => approval.isAvailable);
  const {
    virtualPageAnalyticsData
  } = (0, _contexts.useVirtualPageAnalyticsData)();
  const {
    setPreviousStep
  } = virtualPageAnalyticsData;
  const handleBack = () => {
    setPreviousStep(stepsOrder[activeStep]);
    setActiveStep(activeStep - 1);
  };
  (0, _react.useEffect)(() => {
    isParentalConsent(Boolean(values.parentalConsent?.email ?? values.parentalConsent?.telephone));
  }, [isParentalConsent, values.parentalConsent?.email, values.parentalConsent?.telephone]);
  (0, _react.useEffect)(() => {
    if (!values.parentalConsent?.isChecked && values.termsAndConditions?.termId) {
      trigger();
    }
  }, [values.parentalConsent?.isChecked, trigger, values.termsAndConditions?.termId]);
  const isAnyAprrovalAvailable = Boolean(availableApprovals && availableApprovals.length > 0);
  const isAnyDocumentAvailable =
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical operator ||
  config?.identityCard?.isAvailable || config?.additionalIdentityCard?.isAvailable;
  const isEnabledParentalSection = config?.parentalConsent?.isEnabled;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactHookForm.FormProvider, {
    ...methods,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormValidationSummary.FormValidationSummary, {
      invalidPropertyErrors: invalidCodeErrors,
      customerServiceUrl: customerServiceUrl
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StyledComponentsLegalForm.StyledForm, {
      noValidate: true,
      onSubmit: methods.handleSubmit(onSubmitForm),
      children: [isAnyDocumentAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StyledComponentsLegalForm.DocumentInfoWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h6",
          color: "textPrimary",
          textAlign: "left",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.ThirdStep_Your_Documents_Header,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_Your_Documents_Header
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          color: "textPrimary",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.ThirdStep_Your_Documents_Text,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_Your_Documents_Text
          })
        })]
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
        container: true,
        justifyContent: "center",
        textAlign: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
          size: {
            xs: 12,
            sm: 12
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LegalDocuments.LegalDocuments, {
            documentsConfig: config
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StyledComponentsLegalForm.ConditionsInfoWrapper, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponentsLegalForm.ConditionTitle, {
              variant: "h6",
              color: "textPrimary",
              textAlign: "left",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.ThirdStep_GeneralConditions,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_GeneralConditions
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
              variant: "body1",
              color: "textPrimary",
              textAlign: "left",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.ThirdStep_GeneralConditions_Text,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_GeneralConditions_Text
              })
            })]
          }), isAnyAprrovalAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LegalDetailApprovals.LegalDetailApprovals, {
            config: config,
            approvalValues: values
          }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
            name: "confirmation1",
            label: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
              variant: "body1",
              sx: {
                fontWeight: values.confirmation1 ? 'bold' : 'normal'
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.ThirdStep_Confirmation1,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_Confirmation1,
                values: {
                  LegalDocument1_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument1_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument1_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument1_Link_Label
                    })
                  }),
                  LegalDocument2_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument2_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument2_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument2_Link_Label
                    })
                  }),
                  LegalDocument3_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument3_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument3_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument3_Link_Label
                    })
                  }),
                  LegalDocument4_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument4_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument4_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument4_Link_Label
                    })
                  }),
                  LegalDocument5_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument5_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument5_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument5_Link_Label
                    })
                  }),
                  LegalDocument6_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument6_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument6_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument6_Link_Label
                    })
                  }),
                  LegalDocument7_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument7_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument7_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument7_Link_Label
                    })
                  }),
                  LegalDocument8_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument8_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument8_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument8_Link_Label
                    })
                  })
                }
              }), config?.confirmation1?.validation?.isMandatory ? ' *' : null]
            }),
            value: values.confirmation1,
            ...config?.confirmation1,
            isSubmitting: isSubmitting
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
            name: "confirmation2",
            label: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
              variant: "body1",
              sx: {
                fontWeight: values.confirmation2 ? 'bold' : 'normal'
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                id: _models.TranslationKey.ThirdStep_Confirmation2,
                defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_Confirmation2,
                values: {
                  LegalDocument1_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument1_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument1_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument1_Link_Label
                    })
                  }),
                  LegalDocument2_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument2_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument2_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument2_Link_Label
                    })
                  }),
                  LegalDocument3_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument3_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument3_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument3_Link_Label
                    })
                  }),
                  LegalDocument4_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument4_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument4_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument4_Link_Label
                    })
                  }),
                  LegalDocument5_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument5_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument5_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument5_Link_Label
                    })
                  }),
                  LegalDocument6_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument6_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument6_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument6_Link_Label
                    })
                  }),
                  LegalDocument7_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument7_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument7_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument7_Link_Label
                    })
                  }),
                  LegalDocument8_Link: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                    color: "textPrimary",
                    variant: "body1",
                    href: (0, _contexts.GetContent)(_Localization.ContentKeys.LegalDocument8_Link),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                      id: _models.TranslationKey.LegalDocument8_Link_Label,
                      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.LegalDocument8_Link_Label
                    })
                  })
                }
              }), config?.confirmation2?.validation?.isMandatory ? ' *' : null]
            }),
            value: values.confirmation2,
            ...config?.confirmation2,
            isSubmitting: isSubmitting
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TermsConditionsCheckbox.TermsConditionsCheckbox, {
            config: config
          }), isEnabledParentalSection ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PersonalConsent.ParentalConsent, {
            config: config.parentalConsent,
            handleCheckbox: setIsParentalRequired,
            isUnderParentalConsentAge: isUnderParentalConsentAge
          }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponentsLegalForm.SubmitButtton, {
            variant: "contained",
            color: "primary",
            type: "submit",
            disabled: !isValid || isSubmitting || isSuccessSubmit,
            ...getTestIdProps('submit-btn-legalForm'),
            children: isRedirectToBasketEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              id: _models.TranslationKey.ThirdStep_Button_Continue_Payment,
              defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_Button_Continue_Payment
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              id: _models.TranslationKey.ThirdStep_Button,
              defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_Button
            })
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StyledComponentsLegalForm.BackButtton, {
        variant: "text",
        onClick: () => handleBack(),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponentsLegalForm.StyledArrowIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.back,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.back
        })]
      })]
    })]
  });
};
exports.LegalDetailsForm = LegalDetailsForm;